import { render } from "./AppSidebarRight.vue?vue&type=template&id=674f0208"
import script from "./AppSidebarRight.vue?vue&type=script&lang=js"
export * from "./AppSidebarRight.vue?vue&type=script&lang=js"

import "./AppSidebarRight.vue?vue&type=style&index=0&id=674f0208&lang=css"

import exportComponent from "/Users/robo1/Documents/Admin/admv5-php/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__